import Button, { BUTTON_VARIANT } from '@ab-core/button';
import { ROUTES, logIn } from '@ab-core/functions';
import { navigate } from 'gatsby';
import type { FC } from 'react';
import React from 'react';

type FallbackType = {
    sku: string;
};

export const LogOutFallBack: FC<FallbackType> = (props) => {
    const { sku } = props;

    return (
        <>
            <Button fluid onClick={() => logIn(true)}>
                Anmelden
            </Button>
            <Button variant={BUTTON_VARIANT.OUTLINE} fluid onClick={() => navigate(`${ROUTES.PRODUCTPAGE}/${sku}`)}>
                Zum Produkt
            </Button>
        </>
    );
};
